import React from 'react';
import LeaveManagement from '../LeaveManagement';

const EmployeeLeavesPage = () => {
  return <LeaveManagement />;
};

export default EmployeeLeavesPage;
